var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_12px",
    clipPath: "url(#clip0_2523_340146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.00022H9.99998V1.75811L5.75814 6L5.05299 5.29085L9.34387 1L6.99978 1L6.99978 0L11 0.000220554V4.00022ZM1 3H5V2H1C0.447715 2 0 2.44772 0 3V10C0 10.5523 0.447715 11 1 11H8C8.55229 11 9 10.5523 9 10V6H8V10H1L1 3Z",
    fill: "#686C7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2523_340146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalRedirect);
export default __webpack_public_path__ + "static/media/externalRedirect.d64c34610b2f8865c110d0401e9d15bd.svg";
export { ForwardRef as ReactComponent };